import React, { useState, useEffect, useMemo } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { toast, ToastContainer } from "react-toastify";
import jsPDF from 'jspdf';

// Reusable components
import StatusBadge from "../common/StatusBadge";
import Loader from "../common/Loader";
import FileAttachment from "../common/FileAttachment";
import DocumentCard from "../common/DocumentCard";
import TimelineItem2 from "../common/TimeLineItem2";
import FilePreviewModal from "../common/FilePreviewModal";

import fileUtils from "../../utils/fileUtils";

import {
  fetchGrantById,
  updateGrantStatus,
  fetchGrantStatusOptions,
  fetchtApplicationDetails,
} from "../../redux/actions/grievanceActions1";

import { FETCH_GRANT_DETAILS_SUCCESS } from "../../redux/types";

import grantConfig from "../common/GrantDetailsConfig";

import "bootstrap-icons/font/bootstrap-icons.css";
import "../../styles/GrievanceDetails.css";

const GrantDetails = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const [isLoading, setIsLoading] = useState(false);
  const [isPdfGenerating, setIsPdfGenerating] = useState(false);

  const { esm, centerName, id, grnatDetails } = location.state || {};

  const { user, selectedGrant, loading } = useSelector(
    (state) => state.grievances
  );
  console.log(grnatDetails);
  const currentStatusId = selectedGrant?.current_status_id;
  console.log(selectedGrant);
  const [comments, setComments] = useState("");
  const [fileMetadata, setFileMetadata] = useState([]);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [successMessage, setSuccessMessage] = useState(
    grantConfig?.getStatusName(currentStatusId)
  );
  const [errorMessage, setErrorMessage] = useState("");
  const [activeTab, setActiveTab] = useState("overview");
  const [fileType, setFileType] = useState("");
  const [isPreviewModalOpen, setIsPreviewModalOpen] = useState(false);
  const [previewAttachment, setPreviewAttachment] = useState(null);
  const [updateStatusId, setUpdateStatusId] = useState("");
  const [hideButtons, setHideButtons] = useState(false);

  const userRole = user?.role || 3;

  // Get allowed actions based on role and current status
  const allowedActions = grantConfig.getAllowedActions(
    userRole,
    currentStatusId
  );

  // Check if user can update status
  const canUpdate = grantConfig.canUpdateStatus(userRole, currentStatusId);

  // Check if user can upload documents
  const canUploadDocs = grantConfig.canUploadDocuments(userRole);

  // Check if grant is in final state
  const isInFinalState = grantConfig.isGrantInFinalState(currentStatusId);

  // Format the current status name for display
  const currentStatusName = grantConfig.getStatusName(currentStatusId);

  // PDF Generation Function
  
    // PDF Generation Function
    const generatePDF = async () => {
      setIsPdfGenerating(true);
      
      try {
        const doc = new jsPDF();
        
        // Set document properties
        doc.setProperties({
          title: `Grant Details - C${(selectedGrant?.APP_ID || grnatDetails?.APP_ID)?.toString().padStart(10, "0")}`,
          subject: 'Grant Application Details',
          author: 'SAMPARK SETU Portal',
          keywords: 'grant, application, details',
          creator: 'SAMPARK SETU Portal'
        });
  
        // Helper function to add watermark
        const addWatermark = () => {
          doc.setGState(new doc.GState({opacity: 0.1}));
          doc.setTextColor(200, 200, 200);
          doc.setFontSize(60);
          doc.text('SAMPARK SETU', 105, 150, { 
            align: 'center', 
            angle: 45 
          });
          doc.setGState(new doc.GState({opacity: 1}));
          doc.setTextColor(0, 0, 0);
        };
  
        // Add official header with logo placeholder
        doc.setFillColor(26, 82, 125); // Professional dark blue
        doc.rect(0, 0, 210, 35, 'F');
        
        // Logo placeholder (circle)
        // doc.setFillColor(255, 255, 255);
        // doc.circle(25, 17.5, 8, 'F');
        // doc.setTextColor(26, 82, 125);
        // doc.setFontSize(12);
        // doc.setFont('helvetica', 'bold');
        // doc.text('ARESA', 25, 20, { align: 'center' });
        
        // Main title
        doc.setTextColor(255, 255, 255);
        doc.setFontSize(22);
        doc.setFont('helvetica', 'bold');
        doc.text('GRANT APPLICATION DETAILS', 105, 15, { align: 'center' });
        
        // Subtitle
        // doc.setFontSize(12);
        // doc.setFont('helvetica', 'normal');
        // doc.text('Official Document - Confidential', 105, 25, { align: 'center' });
        
        // Reset text color
        doc.setTextColor(0, 0, 0);
        
        // Document info bar
        doc.setFillColor(245, 245, 245);
        doc.rect(15, 45, 180, 25, 'F');
        doc.setDrawColor(200, 200, 200);
        doc.rect(15, 45, 180, 25, 'S');
        
        // Application details in info bar
        const appId = `C${(selectedGrant?.APP_ID || grnatDetails?.APP_ID)?.toString().padStart(10, "0")}`;
        
        doc.setFontSize(14);
        doc.setFont('helvetica', 'bold');
        doc.text('Application ID:', 20, 55);
        doc.setFont('helvetica', 'normal');
        doc.text(appId, 60, 55);
        
        doc.setFont('helvetica', 'bold');
        doc.text('Grant Type:', 20, 62);
        doc.setFont('helvetica', 'normal');
        doc.text(selectedGrant?.GRANT_TYPE || grnatDetails?.GRANT_TYPE || 'N/A', 55, 62);


      
        doc.setTextColor(34, 139, 34); // Forest green
        doc.setFontSize(10);
        doc.setFont('helvetica', 'bold');
        doc.text(currentStatusName, 140, 58);
     
        
        // Date and reference
        doc.setTextColor(0, 0, 0);
        doc.setFontSize(10);
        doc.setFont('helvetica', 'normal');
        doc.text(`Date: ${selectedGrant?.ENTRY_DATETIME || grnatDetails?.ENTRY_DATETIME || 'N/A'}`, 140, 65);
        
        // Add watermark
        addWatermark();
  
        // Applicant Information Section with enhanced design
        let yPosition = 85;
        
        // Section header with icon placeholder
        doc.setFillColor(52, 152, 219);
        doc.rect(15, yPosition, 180, 15, 'F');
        doc.setTextColor(255, 255, 255);
        doc.setFontSize(14);
        doc.setFont('helvetica', 'bold');
        doc.text(' APPLICANT INFORMATION', 20, yPosition + 10);
        
        yPosition += 20;
        
        // Applicant data with better formatting
        const applicantData = [
          ['Full Name', selectedGrant?.USER_NAME || grnatDetails?.USER_NAME || 'N/A'],
          ['ARESA Center', selectedGrant?.UNIT_CENTRE_NAME || grnatDetails?.UNIT_CENTRE_NAME || centerName || 'N/A'],
          ['Branch Office', selectedGrant?.BRANCH_NAME || grnatDetails?.BRANCH_NAME || 'N/A'],
          ['Contact Number', selectedGrant?.CONTACT_NO || grnatDetails?.CONTACT_NO || 'N/A']
        ];
  
        // Enhanced table with borders
        doc.setDrawColor(150, 150, 150);
        doc.setTextColor(0, 0, 0);
        
        applicantData.forEach((row, index) => {
          const rowHeight = 12;
          const bgColor = index % 2 === 0 ? [248, 249, 250] : [255, 255, 255];
          
          // Background
          doc.setFillColor(...bgColor);
          doc.rect(20, yPosition, 160, rowHeight, 'F');
          
          // Borders
          doc.rect(20, yPosition, 80, rowHeight, 'S');
          doc.rect(100, yPosition, 80, rowHeight, 'S');
          
          // Content
          doc.setFontSize(10);
          doc.setFont('helvetica', 'bold');
          doc.text(row[0], 25, yPosition + 8);
          doc.setFont('helvetica', 'normal');
          doc.text(row[1], 105, yPosition + 8);
          
          yPosition += rowHeight;
        });
  
        // Financial Information Section
        yPosition += 15;
        doc.setFillColor(40, 167, 69);
        doc.rect(15, yPosition, 180, 15, 'F');
        doc.setTextColor(255, 255, 255);
        doc.setFontSize(14);
        doc.setFont('helvetica', 'bold');
        doc.text('FINANCIAL DETAILS', 20, yPosition + 10);
        
        yPosition += 20;
        
        const financialData = [
          ['Pension Amount', `${selectedGrant?.PENSION_AMOUNT || grnatDetails?.PENSION_AMOUNT || grnatDetails?.RELIEF_AMOUNT || '0'}`],
          ['Relief Amount', `${selectedGrant?.RELIEF_AMOUNT || grnatDetails?.RELIEF_AMOUNT || '0'}`],
          ['Earlier Payment', `${selectedGrant?.EARLIER_PAYMENT || grnatDetails?.EARLIER_PAYMENT || '0'}`],
          ['Total Academic Amount', `${selectedGrant?.TOTAL_ACADEMIC_AMOUNT || grnatDetails?.TOTAL_ACADEMIC_AMOUNT || '0'}`]
        ];
  
        financialData.forEach((row, index) => {
          const rowHeight = 12;
          const bgColor = index % 2 === 0 ? [240, 255, 240] : [255, 255, 255];
          
          doc.setFillColor(...bgColor);
          doc.rect(20, yPosition, 160, rowHeight, 'F');
          doc.rect(20, yPosition, 80, rowHeight, 'S');
          doc.rect(100, yPosition, 80, rowHeight, 'S');
          
          doc.setTextColor(0, 0, 0);
          doc.setFontSize(10);
          doc.setFont('helvetica', 'bold');
          doc.text(row[0], 25, yPosition + 8);
          doc.setFont('helvetica', 'bold');
          doc.setTextColor(34, 139, 34);
          doc.text(row[1], 105, yPosition + 8);
          doc.setTextColor(0, 0, 0);
          
          yPosition += rowHeight;
        });
  
        // Grant Specific Details Section
        yPosition += 15;
        
        // Check if new page needed
        if (yPosition > 220) {
          doc.addPage();
          addWatermark();
          yPosition = 30;
        }
        
        doc.setFillColor(156, 39, 176);
        doc.rect(15, yPosition, 180, 15, 'F');
        doc.setTextColor(255, 255, 255);
        doc.setFontSize(14);
        doc.setFont('helvetica', 'bold');
        doc.text('GRANT SPECIFIC INFORMATION', 20, yPosition + 10);
        
        yPosition += 20;
        
        const fieldsToShow = getGrantTypeFields(grnatDetails?.GRANT_TYPE);
        
        fieldsToShow.forEach((field, index) => {
          if (yPosition > 260) {
            doc.addPage();
            addWatermark();
            yPosition = 30;
          }
          
          const rowHeight = 12;
          const bgColor = index % 2 === 0 ? [248, 248, 255] : [255, 255, 255];
          
          doc.setFillColor(...bgColor);
          doc.rect(20, yPosition, 160, rowHeight, 'F');
          doc.rect(20, yPosition, 80, rowHeight, 'S');
          doc.rect(100, yPosition, 80, rowHeight, 'S');
          
          doc.setTextColor(0, 0, 0);
          doc.setFontSize(9);
          doc.setFont('helvetica', 'bold');
          doc.text(field.label, 25, yPosition + 8);
          doc.setFont('helvetica', 'normal');
          
          let value = formatValue(grnatDetails?.[field.key]);
          if (field.key.includes("AMOUNT") || field.key.includes("FEE")) {
            value = `${value}`;
            doc.setTextColor(34, 139, 34);
            doc.setFont('helvetica', 'bold');
          }
          
          // Handle long text
          const maxWidth = 70;
          const textLines = doc.splitTextToSize(value, maxWidth);
          doc.text(textLines[0] || value, 105, yPosition + 8);
          
          doc.setTextColor(0, 0, 0);
          yPosition += rowHeight;
        });
  
        // // Timeline Section (if available)
        // if (selectedGrant?.updates?.length > 0) {
        //   yPosition += 15;
          
        //   if (yPosition > 220) {
        //     doc.addPage();
        //     addWatermark();
        //     yPosition = 30;
        //   }
          
        //   doc.setFillColor(220, 53, 69);
        //   doc.rect(15, yPosition, 180, 15, 'F');
        //   doc.setTextColor(255, 255, 255);
        //   doc.setFontSize(14);
        //   doc.setFont('helvetica', 'bold');
        //   doc.text('STATUS TIMELINE', 20, yPosition + 10);
  
        //   yPosition += 20;
          
        //   // Timeline headers with better spacing
        //   const colWidths = [40, 45, 40, 55];
        //   const colPositions = [20, 60, 105, 145];
          
        //   doc.setFillColor(220, 53, 69);
        //   colWidths.forEach((width, i) => {
        //     doc.rect(colPositions[i], yPosition, width, 12, 'F');
        //   });
          
        //   doc.setTextColor(255, 255, 255);
        //   doc.setFontSize(10);
        //   doc.setFont('helvetica', 'bold');
        //   doc.text('Status', colPositions[0] + 5, yPosition + 8);
        //   doc.text('Date', colPositions[1] + 5, yPosition + 8);
        //   doc.text('Updated By', colPositions[2] + 5, yPosition + 8);
        //   doc.text('Remarks', colPositions[3] + 5, yPosition + 8);
          
        //   yPosition += 12;
        //   doc.setTextColor(0, 0, 0);
        //   doc.setFont('helvetica', 'normal');
          
        //   selectedGrant.updates.forEach((update, index) => {
        //     if (yPosition > 260) {
        //       doc.addPage();
        //       addWatermark();
        //       // yPosition = 30;
        //     }
            
        //     const rowHeight = 15;
        //     const bgColor = index % 2 === 0 ? [255, 245, 245] : [255, 255, 255];
            
        //     doc.setFillColor(...bgColor);
        //     colWidths.forEach((width, i) => {
        //       doc.rect(colPositions[i], yPosition, width, rowHeight, 'F');
        //       doc.rect(colPositions[i], yPosition, width, rowHeight, 'S');
        //     });
            
        //     doc.setFontSize(8);
        //     doc.text(doc.splitTextToSize(update.status_name || 'N/A', colWidths[0] - 5)[0], colPositions[0] + 2, yPosition + 8);
        //     doc.text(doc.splitTextToSize(update.entry_datetime || 'N/A', colWidths[1] - 5)[0], colPositions[1] + 2, yPosition + 8);
        //     doc.text(doc.splitTextToSize(update.user_name || 'N/A', colWidths[2] - 5)[0], colPositions[2] + 2, yPosition + 8);
        //     doc.text(doc.splitTextToSize(update.remarks || 'N/A', colWidths[3] - 5)[0], colPositions[3] + 2, yPosition + 8);
            
        //     yPosition += rowHeight;
        //   });
        // }
  
        // Official footer with validation
        const pageCount = doc.internal.getNumberOfPages();
        for (let i = 1; i <= pageCount; i++) {
          doc.setPage(i);
          
          // Footer background
          doc.setFillColor(245, 245, 245);
          doc.rect(0, 280, 210, 17, 'F');
          doc.setDrawColor(200, 200, 200);
          doc.line(15, 280, 195, 280);
          
          // Footer content
          doc.setTextColor(100, 100, 100);
          doc.setFontSize(8);
          doc.setFont('helvetica', 'normal');
          doc.text(`Generated on: ${new Date().toLocaleString('en-IN')}`, 20, 287);
          doc.text(`Page ${i} of ${pageCount}`, 105, 287, { align: 'center' });
          doc.text('SAMPARK SETU - Official Document', 190, 287, { align: 'right' });
          // SAMPARK SETU
          // Security footer
          doc.setFontSize(7);
          doc.text('This is a computer-generated document. No signature required.', 105, 292, { align: 'center' });
          doc.text(`Document ID: ${appId}-${new Date().getTime()}`, 105, 295, { align: 'center' });
        }
  
        // Save with enhanced filename
        const timestamp = new Date().toISOString().replace(/[:.]/g, '-');
        const fileName = `Grant_Detail_${appId}_${timestamp.split('T')[0]}.pdf`;
        doc.save(fileName);
        
        toast.success('Report downloaded successfully!');
        
      } catch (error) {
        console.error('Error generating PDF:', error);
        toast.error('Failed to generate PDF. Please try again.');
      } finally {
        setIsPdfGenerating(false);
      }
    };
    

  // Fetch data on component mount
  useEffect(() => {
    const fetchData = async () => {
      try {
        if (id) {
          await dispatch(fetchGrantById(id));
          await dispatch(fetchGrantStatusOptions());
          if (esm) {
            await dispatch(fetchtApplicationDetails(esm));
          }
        }
      } catch (error) {
        console.error("Error fetching grant data:", error);
      }
    };

    fetchData();
  }, [id, esm, dispatch]);

  // Get all attachments from grant updates
  const getAllAttachments = () => {
    const attachments = [];
    if (selectedGrant?.updates) {
      for (const update of selectedGrant.updates) {
        if (update?.attachments && update.attachments.length > 0) {
          attachments.push(...update.attachments);
        }
      }
    }
    return attachments;
  };

  const allAttachments = getAllAttachments();
  console.log(grnatDetails);

  // Handler functions
  const handleFileChange = (newFileMetadata) => {
    setFileMetadata(newFileMetadata);
  };

  const resetForm = () => {
    setUpdateStatusId("");
    setComments("");
    setFileMetadata([]);
    setErrorMessage("");
  };

  const closePreviewModal = () => {
    setIsPreviewModalOpen(false);
    setPreviewAttachment(null);
  };

  const handleTimelineAttachmentPreview = (state, attachment, name) => {
    setIsLoading(state);
    setPreviewAttachment(attachment);
    setFileType(name);
    if (!state) {
      setIsPreviewModalOpen(true);
    }
  };

  const handleUpdateStatus = async (statusId) => {
    if (!statusId) {
      setErrorMessage("Invalid status");
      return;
    }

    if (!comments) {
      setErrorMessage("Please provide remarks");
      return;
    }

    setUpdateStatusId(statusId);
    setIsSubmitting(true);
    setSuccessMessage("");
    setErrorMessage("");
    setHideButtons(true);

    try {
      let processedFiles = [];

      if (fileMetadata.length > 0 && canUploadDocs) {
        try {
          const files = fileMetadata.filter((meta) => meta instanceof File);

          if (files.length > 0) {
            processedFiles = await fileUtils.filesToAttachments(files);
          }
        } catch (fileError) {
          console.error("Error processing attachments:", fileError);
          setErrorMessage(`Error processing attachments: ${fileError.message}`);
          setIsSubmitting(false);
          setHideButtons(false);
          return;
        }
      }

      const statusName = grantConfig.getStatusName(statusId);

      if (selectedGrant) {
        const updatedGrant = {
          ...selectedGrant,
          STATUS_NAME: statusName,
          STATUS_ID: statusId,
        };

        dispatch({
          type: FETCH_GRANT_DETAILS_SUCCESS,
          payload: updatedGrant,
        });
      }

      const res = await dispatch(
        updateGrantStatus(
          id,
          statusId,
          comments,
          user?.id || "0",
          processedFiles
        )
      );

      if (res.rCode == 0) {
        alert(res.rMessage || "Grant Updated Successfully");
      } else {
        alert(res.rMessage || "error");
      }

      setTimeout(() => {
        window.location.reload();
      }, 100);

      resetForm();
      await dispatch(fetchGrantById(id));
      await dispatch(fetchtApplicationDetails(esm));
    } catch (error) {
      setErrorMessage(error.message || "Failed to update grant status");
      console.error("Status update error:", error);
      setHideButtons(false);
    } finally {
      setIsSubmitting(false);
      setUpdateStatusId("");
      setActiveTab("overview");
    }
  };

  const statusMessage = grantConfig.getStatusMessage(currentStatusId);
  const cannotUpdateMessage =
    grantConfig.getCannotUpdateMessage(currentStatusId);
    
  const getGrantTypeFields = (grantType) => {
    const commonFields = [
      { key: "USER_NAME", label: "Applicant Name" },
      { key: "UNIT_CENTRE_NAME", label: "Center Name" },
      { key: "BRANCH_NAME", label: "Branch Name" },
      { key: "ENTRY_DATETIME", label: "Submission Date" },
      { key: "GRANT_TYPE", label: "Grant Type" },
      { key: "STATUS_NAME", label: "Current Status" },
      { key: "REMARKS", label: "Remarks" },
    ];

    const bankFields = [
      { key: "ACCOUNT_HOLDER_NAME", label: "Account Holder Name" },
      { key: "BANK_ACCOUNT_NO", label: "Bank Account Number" },
      { key: "IFSC_CODE", label: "IFSC Code" },
      { key: "CONTACT_NO", label: "Contact Number" },
    ];

    switch (grantType?.toUpperCase()) {
      case "SCHOOL EDN GRANT":
        return [
          ...commonFields,
          { key: "STUDENT_NAME", label: "Student Name" },
          { key: "DOB", label: "Date of Birth" },
          { key: "CURRENT_CLASS", label: "Current Class" },
          { key: "TUITION_FEE", label: "Tuition Fee" },
          { key: "ADDRESS", label: "Address" },
          { key: "SCHOOL_NAME", label: "School Name" },
          { key: "SCHOOL_ADDRESS", label: "School Address" },
          { key: "TOTAL_ACADEMIC_AMOUNT", label: "Total Academic Amount" },
          ...bankFields,
        ];

      case "HIGHER EDN GRANT":
        return [
          ...commonFields,
          {
            key: grnatDetails.PENSION_AMOUNT
              ? "PENSION_AMOUNT"
              : "RELIEF_AMOUNT",
            label: grnatDetails.PENSION_AMOUNT
              ? "Pension Amount"
              : "Pension Amount",
          },
          { key: "EARLIER_PAYMENT", label: "Earlier Payment" },
          { key: "STUDENT_NAME", label: "Student Name" },
          { key: "DOB", label: "Date of Birth" },
          { key: "COLLEGE_UNIVERSITY_NAME", label: "College/University Name" },
          {
            key: "COLLEGE_UNIVERSITY_ADDRESS",
            label: "College/University Address",
          },
          { key: "CURRENT_CLASS", label: "Current Class" },
          { key: "TOTAL_ACADEMIC_AMOUNT", label: "Total Academic Amount" },
          { key: "PREVIOUS_EXAM_RESULT", label: "Previous Exam Result" },
          ...bankFields,
        ];

      case "NATURAL CALAMITY (OTG)":
      case "MARRIAGE GRANT":
      case "FUNERAL GRANT":
      case "OLD AGE GRANT":
        return [
          ...commonFields,
          { key: "CAUSE_OF_DISCHARGE", label: "Cause of Discharge" },
          { key: "RELATION_NAME", label: "Relationship" },
          { key: "PARTICULARS_DEPENDENTS", label: "Particulars of Dependents" },
          { key: "GROUNDS_FOR_RELIEF", label: "Grounds for Relief" },
          { key: "PENSION_AMOUNT", label: "Pension Amount" },
          { key: "EARLIER_PAYMENT", label: "Earlier Payment" },
          { key: "DISABILITY", label: "Disability" },
          { key: "RELIEF_AMOUNT", label: "Relief Amount" },
          ...bankFields,
        ];

      case "MEDICAL AID GRANT":
        return [
          ...commonFields,
          { key: "PATIENT_NAME", label: "Patient Name" },
          { key: "RELATION_NAME", label: "Relationship" },
          { key: "DOB", label: "Date of Birth" },
          { key: "DISEASE_SUFERRING_FROM", label: "Disease Suffering From" },
          { key: "DOCTOR_NAME", label: "Doctor Name" },
          { key: "HOSPITAL_NAME", label: "Hospital Name" },
          { key: "HOSPITAL_ADMIT_DATE", label: "Hospital Admit Date" },
          { key: "HOSPITAL_DISCHARGE_DATE", label: "Hospital Discharge Date" },
          { key: "RELIEF_AMOUNT", label: "Relief Amount" },
          ...bankFields,
        ];

      default:
        return [
          ...commonFields,
          { key: "PENSION_AMOUNT", label: "Pension Amount" },
          { key: "RELIEF_AMOUNT", label: "Relief Amount" },
        ];
    }
  };

  const fieldsToShow = getGrantTypeFields(grnatDetails?.GRANT_TYPE);

  const formatValue = (value) => {
    if (!value || value === "N/A" || value === "") return "N/A";
    return value;
  };

  const getGrantTypeColor = (grantType) => {
    switch (grantType?.toUpperCase()) {
      case "SCHOOL EDN GRANT":
        return "badge bg-primary";
      case "HIGHER EDN GRANT":
        return "badge bg-success";
      case "NATURAL CALAMITY (OTG)":
        return "badge bg-warning";
      case "MEDICAL GRANT":
        return "badge bg-danger";
      case "MARRIAGE":
        return "badge bg-info";
      case "FUNERAL":
        return "badge bg-dark";
      case "OLD AGE":
        return "badge bg-secondary";
      default:
        return "badge bg-light text-dark";
    }
  };

  return (
    <div className="grievance-details-container">
      <FilePreviewModal
        isOpen={isPreviewModalOpen}
        onClose={closePreviewModal}
        attachment={previewAttachment}
        fileTypes={fileType}
      />

      {/* Floating Action Buttons */}
      <div className="floating-actions">
        <button
          className="fab-button"
          onClick={() => navigate("/GrantList")}
          title="Back to grants"
        >
          <i className="bi bi-arrow-left"></i>
        </button>
      </div>

      {/* Grant Header */}
      <div className="grievance-details-header">
        <div className="grievance-details-title">
          <div className="title-icon">
            <i className="bi bi-clipboard-check"></i>
          </div>
          <div>
            <h2>
              C
              {(selectedGrant?.APP_ID || grnatDetails?.APP_ID)
                ?.toString()
                .padStart(10, "0")}
            </h2>
            <p className="grievance-subtitle">
              {selectedGrant?.GRANT_TYPE || grnatDetails?.GRANT_TYPE} •{" "}
              {selectedGrant?.ENTRY_DATETIME || grnatDetails?.ENTRY_DATETIME}
            </p>
          </div>
        </div>
        <div className="header-actions">
          <StatusBadge status={currentStatusName} isGrant={true} size="large" />
          <button
          style={{marginLeft:30,marginTop:10}}
            className="btn btn-outline-primary  d-flex align-items-center"
            onClick={generatePDF}
            disabled={isPdfGenerating}
            title="Download PDF Report"
          >
            {isPdfGenerating ? (
              <>
                <i className="bi bi-hourglass-split me-2"></i>
                Generating...
              </>
            ) : (
              <>
                <i className="bi bi-file-earmark-pdf me-2"></i>
                Download PDF
              </>
            )}
          </button>
        </div>
      </div>

      {/* Tab Navigation */}
      <div className="grievance-details-tabs">
        <button
          className={`tab-button ${activeTab === "overview" ? "active" : ""}`}
          onClick={() => setActiveTab("overview")}
        >
          <i className="bi bi-info-circle"></i> Overview
        </button>
        <button
          className={`tab-button ${
            activeTab === "grantDetails" ? "active" : ""
          }`}
          onClick={() => setActiveTab("grantDetails")}
        >
          <i className="bi bi-info-circle"></i> Grant Details
        </button>
        <button
          className={`tab-button ${activeTab === "timeline" ? "active" : ""}`}
          onClick={() => setActiveTab("timeline")}
        >
          <i className="bi bi-clock-history"></i> Status Trail
          {selectedGrant?.updates?.length > 0 && (
            <span className="tab-badge">{selectedGrant?.updates?.length}</span>
          )}
        </button>
        <button
          className={`tab-button ${activeTab === "documents" ? "active" : ""}`}
          onClick={() => setActiveTab("documents")}
        >
          <i className="bi bi-file-earmark"></i> Documents
          {allAttachments?.length > 0 && (
            <span className="tab-badge">{allAttachments?.length}</span>
          )}
        </button>
        {canUpdate && !isInFinalState && (
          <button
            className={`tab-button ${activeTab === "update" ? "active" : ""}`}
            onClick={() => setActiveTab("update")}
          >
            <i className="bi bi-pencil-square"></i> Update Progress
          </button>
        )}
      </div>

      {/* Tab Content */}
      <div className="grievance-details-content">
        {/* Overview Tab */}
        {activeTab === "overview" && (
          <div className="grievance-details-panel">
            {/* Applicant Information Card */}
            <div className="grievance-details-card applicant-card">
              <div className="card-header">
                <h3>
                  <i className="bi bi-person"></i> Applicant Information
                </h3>
                <div className="card-avatar">
                  <span>
                    {(
                      selectedGrant?.USER_NAME || grnatDetails?.USER_NAME
                    )?.charAt(0) || "U"}
                  </span>
                </div>
              </div>
              <div className="card-body">
                <div className="applicant-name">
                  {selectedGrant?.USER_NAME || grnatDetails?.USER_NAME}
                </div>

                <div className="info-grid">
                  <div className="info-item">
                    <div className="info-icon">
                      <i className="bi bi-calendar2"></i>
                    </div>
                    <div>
                      <div className="info-label">Submission Date</div>
                      <div className="info-value">
                        {selectedGrant?.ENTRY_DATETIME ||
                          grnatDetails?.ENTRY_DATETIME ||
                          "N/A"}
                      </div>
                    </div>
                  </div>

                  <div className="info-item">
                    <div className="info-icon">
                      <i className="bi bi-building"></i>
                    </div>
                    <div>
                      <div className="info-label">ARESA Center</div>
                      <div className="info-value">
                        {selectedGrant?.UNIT_CENTRE_NAME ||
                          grnatDetails?.UNIT_CENTRE_NAME ||
                          centerName ||
                          "N/A"}
                      </div>
                    </div>
                  </div>

                  <div className="info-item">
                    <div className="info-icon">
                      <i className="bi bi-currency-rupee"></i>
                    </div>
                    <div>
                      <div className="info-label">Pension Amount</div>
                      <div className="info-value">
                        ₹
                        {selectedGrant?.PENSION_AMOUNT ||
                          grnatDetails?.PENSION_AMOUNT ||
                          grnatDetails.RELIEF_AMOUNT}
                      </div>
                    </div>
                  </div>

                  <div className="info-item">
                    <div className="info-icon">
                      <i className="bi bi-currency-rupee"></i>
                    </div>
                    <div>
                      <div className="info-label">Relief Amount</div>
                      <div className="info-value">
                        ₹
                        {selectedGrant?.RELIEF_AMOUNT ||
                          grnatDetails?.RELIEF_AMOUNT ||
                          "0"}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Grant Details Card */}
            <div className="grievance-details-card description-card">
              <div className="card-header">
                <h3>
                  <i className="bi bi-chat-left-text"></i> Grant Details
                </h3>
              </div>
              <div className="card-body">
                <div className="category-badge">
                  <i className="bi bi-tag-fill"></i>
                  <span>
                    {selectedGrant?.GRANT_TYPE || grnatDetails?.GRANT_TYPE}
                  </span>
                </div>

                <div className="description-box">
                  <div className="description-title">
                    <i className="bi bi-card-text"></i> Remarks
                  </div>
                  <div className="description-content">
                    {selectedGrant?.REMARKS ||
                      grnatDetails?.REMARKS ||
                      "No remarks provided"}
                  </div>
                </div>

                <div className="status-action-section">
                  <div className="current-status">
                    <p className="status-label">Current Status</p>
                    <StatusBadge status={currentStatusName} isGrant={true} />
                  </div>

                  {canUpdate && !isInFinalState && (
                    <button
                      className="button primary"
                      onClick={() => setActiveTab("update")}
                    >
                      <i className="bi bi-pencil-square"></i>
                      Update Status
                    </button>
                  )}
                </div>
              </div>
            </div>
          </div>
        )}

        {activeTab === "grantDetails" && (
          <div className="grievance-details-panel full-width">
            <div className="grievance-details-card">
              <div className="card-header">
                <h3>
                  <i className="bi bi-info-circle"></i> Grant Details
                </h3>
              </div>
              <div className="card-body">
                <div className="table-responsive">
                  <table className="table table-hover table-bordered">
                    <tbody>
                      {fieldsToShow.reduce((rows, field, index) => {
                        if (index % 2 === 0) {
                          const nextField = fieldsToShow[index + 1];
                          rows.push(
                            <tr key={index}>
                              {/* First column pair */}
                              <th className="text-nowrap bg-light" style={{ width: "20%" }}>
                                {field.label}
                              </th>
                              <td style={{ width: "30%" }}>
                                {field.key === "GRANT_TYPE" ? (
                                  <span className={getGrantTypeColor(grnatDetails?.[field.key])}>
                                    {formatValue(grnatDetails?.[field.key])}
                                  </span>
                                ) : field.key === "STATUS_NAME" ? (
                                  <span className="badge bg-success">
                                    {formatValue(grnatDetails?.[field.key])}
                                  </span>
                                ) : field.key.includes("AMOUNT") || field.key.includes("FEE") ? (
                                  <span className="fw-bold text-success">
                                    ₹{formatValue(grnatDetails?.[field.key])}
                                  </span>
                                ) : (
                                  formatValue(grnatDetails?.[field.key])
                                )}
                              </td>
                              
                              {/* Second column pair */}
                              {nextField ? (
                                <>
                                  <th className="text-nowrap bg-light" style={{ width: "20%" }}>
                                    {nextField.label}
                                  </th>
                                  <td style={{ width: "30%" }}>
                                    {nextField.key === "GRANT_TYPE" ? (
                                      <span className={getGrantTypeColor(grnatDetails?.[nextField.key])}>
                                        {formatValue(grnatDetails?.[nextField.key])}
                                      </span>
                                    ) : nextField.key === "STATUS_NAME" ? (
                                      <span className="badge bg-success">
                                        {formatValue(grnatDetails?.[nextField.key])}
                                      </span>
                                    ) : nextField.key.includes("AMOUNT") || nextField.key.includes("FEE") ? (
                                      <span className="fw-bold text-success">
                                        ₹{formatValue(grnatDetails?.[nextField.key])}
                                      </span>
                                    ) : (
                                      formatValue(grnatDetails?.[nextField.key])
                                    )}
                                  </td>
                                </>
                              ) : (
                                // Empty cells if odd number of fields
                                <>
                                  <th className="bg-light"></th>
                                  <td></td>
                                </>
                              )}
                            </tr>
                          );
                        }
                        return rows;
                      }, [])}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        )}

        {/* Timeline Tab */}
        {activeTab === "timeline" && (
          <div className="grievance-details-panel full-width">
            <div className="grievance-details-card">
              <div className="card-header">
                <h3>
                  <i className="bi bi-clock-history"></i> Grant Timeline
                </h3>
              </div>
              <div className="card-body">
                {selectedGrant?.updates?.length > 0 ? (
                  <div className="timeline-container">
                    {selectedGrant.updates.map((entry, index) => (
                      <TimelineItem2
                        key={index}
                        status_name={entry.status_name}
                        action={entry.remarks}
                        date={entry.entry_datetime}
                        comments={entry.remarks}
                        attachments={entry.attachments}
                        user_name={entry.user_name}
                        onPreviewAttachment={handleTimelineAttachmentPreview}
                        isLoading={isLoading}
                        isLast={index === selectedGrant.updates.length - 1}
                        isFirst={index === 0}
                        type="grant"
                      />
                    ))}
                  </div>
                ) : (
                  <div className="empty-state">
                    <div className="empty-icon">
                      <i className="bi bi-clock-history"></i>
                    </div>
                    <p>No timeline events available for this grant yet.</p>
                  </div>
                )}
              </div>
            </div>
          </div>
        )}

        {/* Documents Tab */}
        {activeTab === "documents" && (
          <div className="grievance-details-panel full-width">
            <div className="grievance-details-card">
              <div className="card-header">
                <h3>
                  <i className="bi bi-files"></i> Attached Documents
                </h3>
              </div>
              <div className="card-body">
                {allAttachments?.length > 0 ? (
                  <>
                    <ul className="document-categories">
                      <li className="category-active">All Documents</li>
                    </ul>

                    <div className="documents-grid">
                      {allAttachments.map((attachment, index) => (
                        <DocumentCard
                          key={index}
                          filename={attachment.att_name}
                          attachmentId={attachment.grant_att_id}
                          type="grant"
                          onPreview={handleTimelineAttachmentPreview}
                          isLoading={isLoading}
                        />
                      ))}
                    </div>
                  </>
                ) : (
                  <div className="empty-state">
                    <div className="empty-icon">
                      <i className="bi bi-file-earmark-x"></i>
                    </div>
                    <p>No documents attached to this grant</p>
                    {canUploadDocs && !isInFinalState && (
                      <button
                        className="empty-action"
                        onClick={() => setActiveTab("update")}
                      >
                        <i className="bi bi-upload"></i> Upload Documents
                      </button>
                    )}
                  </div>
                )}
              </div>
            </div>
          </div>
        )}

        {/* Update Status Tab */}
        {activeTab === "update" && (
          <div className="grievance-details-panel full-width">
            <div className="grievance-details-card">
              <div className="card-header">
                <h3>
                  <i className="bi bi-pencil-square"></i> Update Status
                </h3>
              </div>
              <div className="card-body">
                {canUpdate ? (
                  <div className="update-form">
                    {!hideButtons && (
                      <>
                        <div className="form-group">
                          <label htmlFor="comments">
                            <i className="bi bi-chat-text"></i> Remarks
                          </label>
                          <textarea
                            id="comments"
                            className="form-control"
                            rows="4"
                            value={comments}
                            onChange={(e) => setComments(e.target.value)}
                            placeholder="Add your remarks or notes"
                            disabled={isSubmitting}
                          ></textarea>
                        </div>

                        {canUploadDocs && (
                          <div className="form-group">
                            <label>
                              <i className="bi bi-paperclip"></i> Supporting
                              Documents
                            </label>
                            <FileAttachment
                              onChange={handleFileChange}
                              maxFiles={5}
                              maxSize={fileUtils.MAX_FILE_SIZE}
                              showPreview={true}
                              previewSize="small"
                              disabled={isSubmitting}
                              label="Attach Files (up to 5)"
                              helpText={`Supported formats: ${Object.keys(
                                fileUtils.ALLOWED_FILE_TYPES
                              )
                                .join(", ")
                                .toUpperCase()} (Max: ${fileUtils.formatFileSize(
                                fileUtils.MAX_FILE_SIZE
                              )} per file)`}
                            />

                            {/* {fileMetadata.length > 0 && (
                              <div className="attachment-container mt-3">
                                <div className="attachment-count">
                                  <i className="bi bi-paperclip"></i>{" "}
                                  {fileMetadata.length} file(s) attached
                                </div>
                                <div className="attachment-list">
                                  {fileMetadata.map((file, index) => (
                                    <div
                                      className="attachment-item"
                                      key={index}
                                    >
                                      <div className="attachment-icon">
                                        <i
                                          className={`bi ${
                                            fileUtils.getFileIconAndClass(
                                              file.name
                                            ).icon
                                          }`}
                                        ></i>
                                      </div>
                                      <div className="attachment-name">
                                        {file.name}
                                      </div>
                                      <button
                                        className="attachment-remove"
                                        onClick={() => {
                                          const newFiles = [...fileMetadata];
                                          newFiles.splice(index, 1);
                                          handleFileChange(newFiles);
                                        }}
                                        type="button"
                                        disabled={isSubmitting}
                                      >
                                        <i className="bi bi-x"></i>
                                      </button>
                                    </div>
                                  ))}
                                </div>
                              </div>
                            )} */}
                          </div>
                        )}
                      </>
                    )}
                    <div className="aresa-form-actions">
                      {!hideButtons &&
                        allowedActions.map((action) => (
                          <button
                            key={action.id}
                            className={action.buttonClass}
                            onClick={() => handleUpdateStatus(action.id)}
                            disabled={isSubmitting || !comments}
                            type="button"
                            title={action.description}
                          >
                            {isSubmitting && updateStatusId === action.id ? (
                              <>
                                <i
                                  className={`bi ${action.icon} icon-spin`}
                                ></i>{" "}
                                Processing...
                              </>
                            ) : (
                              <>
                                <i className={`bi ${action.icon}`}></i>{" "}
                                {action.label}
                              </>
                            )}
                          </button>
                        ))}
                    </div>
                  </div>
                ) : isInFinalState ? (
                  <></>
                ) : (
                  <></>
                )}
              </div>
            </div>
          </div>
        )}
      </div>
      {isLoading && <Loader></Loader>}
      <ToastContainer />
    </div>
  );
};

export default GrantDetails;